
import { Flex, Icon } from '@lideralia/alife-uikit';
import { ButtonTabs } from '@lideralia/alife-uikit/dist/atoms/Button';
import { IconAgency, IconSee, IconSupport } from '@lideralia/alife-uikit/dist/atoms/Icons';
import { Container } from '@lideralia/alife-uikit/dist/atoms/Layout';
import { Loader } from '@lideralia/alife-uikit/dist/atoms/Loader';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SERVICE_CATEGORIES } from '../../../../utilities';
import { ServicesComponent } from '../../../common/components/Services';
import { getActualLanguage } from '../../../common/functions/lang';

import { getLineServicesByCategory, getLineServicesLoading } from '../../../common/schemes/line_services/selectors';

export const ServicesTemplate = (props) => {
    const { line } = props;
    const history = useHistory();
    const lang = getActualLanguage();

    const [ serviceCategory, setServiceCategory ] = useState(null);
    
    // Selectores
    const lineServices = useSelector(state => getLineServicesByCategory(state, serviceCategory));
    const loading = useSelector(getLineServicesLoading);

    const isAdmin = (line?.permissionType ?? 0) > 3;
    const handleEditorBannerClick = () =>
      history.push(`/${lang}/lines/${line?.lineId}/${line?.nameUrl?.replaceAll(/[^\w\-\s]/gi, '')}/biographical-editor`);
/*
    // Fetch services when component mounts or line changes
    useEffect(() => {
        if (line?.lineId) {
          console.log('Dispatching getLineServices for line:', line.lineId);
          dispatch(getLineServices(line.lineId));
        }
    }, [dispatch, line?.lineId]);
*/
    const itemsTab = [
      {
        id: 'services_all',
        children: (
          <>
            <Icon marginRight={1}>
              <IconSee width="18px" height="18px" />
            </Icon>
            <FormattedMessage id="services.tabServicesAll" />
          </>
        ),
        isActive: !serviceCategory,
        action: () => {
          setServiceCategory(null);
        },
      },
      {
        id: 'services_tribute',
        children: (
          <>
            <Icon marginRight={1}>
              <IconSupport width="18px" height="18px" />
            </Icon>
            <FormattedMessage id="services.tabServicesTribute" />
          </>
        ),
        style: {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          display: 'flex',
          overflow: 'hidden',
          minWidth: '58px',
          margin: '0',
        },
        isActive: serviceCategory === SERVICE_CATEGORIES.TRIBUTE,
        action: () => {
          setServiceCategory(SERVICE_CATEGORIES.TRIBUTE);
        },
      },
      {
        id: 'services_service',
        children: (
          <>
            <Icon marginRight={1}>
              <IconAgency width="18px" height="18px" />
            </Icon>{' '}
            <FormattedMessage id="services.tabServicesService" />
          </>
        ),
        isActive: serviceCategory === SERVICE_CATEGORIES.SERVICE,
        action: () => {
          setServiceCategory(SERVICE_CATEGORIES.SERVICE);
        },
      },
    ];

    return (!line || loading) ? 
      <Loader customColor={line?.company?.style?.primaryColor} />
      :
      (
      <Container paddingY={3} paddingBottom={10} maxWidth={['400px']} {...props}>
        <Flex alignItems="center" flexDirection="column" justifyContent="center" paddingBottom={6}>
          <Flex marginBottom={3} alignItems="center" justifyContent="center" width="100%" maxWidth='339px'>
            <ButtonTabs width="100%" items={itemsTab} />
          </Flex>
          <ServicesComponent
            showEmptyCategoriesMessage
            showServicesOfCategory={serviceCategory}
            lineServices={lineServices}
            isAdmin={isAdmin}
            onEditorBannerClick={handleEditorBannerClick}
          />
        </Flex>
      </Container>
    );
};